import Card from "../ui/card/Card";
import Button from "../common/button/Button";
import Icon from "../ui/Icon";

const SettingDetail = ({enableDisable, GSTIN, orderInvoice, invoiceSetting, primaryBank, closeModal}) => {
    return (
        <>
            <Button className="d-block ms-auto m-4 mb-0 rounded-pill p-1" onClick={closeModal}>
                <Icon name="cross" width={23} height={20}/>
            </Button>
            <div className="p-4">
                {/*Currently active*/}
                <h6 className="text-primary bg-primary bg-opacity-15 p-2 rounded-2 mb-4 text-center border border-success">Currently
                    Active</h6>
                <div className="row gy-4">
                    {/*Order Invoice Details*/}
                    <div className="col-md-6">
                        <Card className="bg-primary border-0 bg-opacity-15 h-100">
                            <h6 className="border-bottom border-primary text-primary mb-3 pb-1">Order Invoice Details
                                {orderInvoice?.prefix && orderInvoice?.year && orderInvoice?.startSeq
                                    ? ` - ${orderInvoice.prefix}/${orderInvoice.year}/${orderInvoice.startSeq}`
                                    : ""}
                            </h6>
                            <div className="row gy-2">
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Prefix</p>
                                    <p className="m-0 fs-md text-secondary"> {orderInvoice.prefix ? orderInvoice.prefix : 'Not Available'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Year</p>
                                    <p className="m-0 fs-md text-secondary">{orderInvoice.year ? orderInvoice.year : 'Not Available'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Start Sequence</p>
                                    <p className="m-0 fs-md text-secondary">{orderInvoice.startSeq ? orderInvoice.startSeq : 'Not Available'}</p>
                                </div>
                            </div>
                        </Card>
                    </div>

                    {/*Invoice Details*/}
                    <div className="col-md-6">
                        <Card className="bg-primary border-0 bg-opacity-15 h-100">
                            <h6 className="border-bottom border-primary text-primary mb-3 pb-1"> Invoice Details
                                {invoiceSetting?.prefix && invoiceSetting?.year && invoiceSetting?.startSeq
                                    ? ` - ${invoiceSetting.prefix}/${invoiceSetting.year}/${invoiceSetting.startSeq}`
                                    : ""}
                            </h6>
                            <div className="row gy-2">
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Prefix</p>
                                    <p className="m-0 fs-md text-secondary"> {invoiceSetting.prefix ? invoiceSetting.prefix : 'Not Available'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Year</p>
                                    <p className="m-0 fs-md text-secondary">{invoiceSetting.year ? invoiceSetting.year : 'Not Available'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Start Sequence</p>
                                    <p className="m-0 fs-md text-secondary">{invoiceSetting.startSeq ? invoiceSetting.startSeq : 'Not Available'}</p>
                                </div>
                            </div>
                        </Card>
                    </div>

                    {/*GSTIN Number*/}
                    <div className="col-md-6">
                        <Card className="border-0 bg-primary bg-opacity-15 h-100">
                            <h6 className="border-bottom border-primary text-primary mb-3 pb-1">GST Details</h6>
                            <div>
                                <p className="m-0 fs-md">GSTIN No.</p>
                                <p className="m-0 fs-md text-secondary">{GSTIN ? GSTIN : 'Not Available'}</p>
                            </div>
                        </Card>
                    </div>

                    {/*Bank Details*/}
                    <div className="col-md-6">
                        <Card className="bg-primary border-0 bg-opacity-15 h-100">
                            <h6 className="border-bottom border-primary text-primary mb-3 pb-1">Primary Bank</h6>
                            <div className="row gy-2">
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Bank</p>
                                    <p className="m-0 fs-md text-secondary"> {primaryBank.name ? primaryBank.name : 'Not Available'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Account Holder Name</p>
                                    <p className="m-0 fs-md text-secondary">{primaryBank.accountHolderName ? primaryBank.accountHolderName : 'Not Available'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Account Number</p>
                                    <p className="m-0 fs-md text-secondary">{primaryBank.accountNumber ? primaryBank.accountNumber : 'Not Available'}</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">IFSC Code</p>
                                    <p className="m-0 fs-md text-secondary">{primaryBank.ifscCode ? primaryBank.ifscCode : 'Not Available'}</p>
                                </div>
                                <div className="col-md-12">
                                    <p className="m-0 fs-md">Branch Address</p>
                                    <p className="m-0 fs-md text-secondary">{primaryBank.branchAddress ? primaryBank.branchAddress : 'Not Available'}</p>
                                </div>
                            </div>
                        </Card>
                    </div>

                    {/*Enable disable*/}
                    <div className="col-md-6">
                        <Card className="bg-primary border-0 bg-opacity-15 h-100">
                            <h6 className="border-bottom border-primary text-primary mb-3 pb-1">Toggle Settings</h6>
                            <div className="row gy-2">
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Bank Print</p>
                                    <p className="m-0 fs-md text-secondary">
                                        {enableDisable.bankPrint === true
                                            ? "Enabled"
                                            : enableDisable.bankPrint === false
                                                ? "Disabled"
                                                : "Not Available"}
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Enable GST</p>
                                    <p className="m-0 fs-md text-secondary">
                                        {enableDisable.gstPrint === true
                                            ? "Enabled"
                                            : enableDisable.gstPrint === false
                                                ? "Disabled"
                                                : "Not Available"}
                                    </p>

                                </div>
                                <div className="col-md-6">
                                    <p className="m-0 fs-md">Enable SAC Code</p>
                                    <p className="m-0 fs-md text-secondary">
                                        {enableDisable.sacCode === true
                                            ? "Enabled"
                                            : enableDisable.sacCode === false
                                                ? "Disabled"
                                                : "Not Available"}
                                    </p>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SettingDetail